"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[4651],{

/***/ 19639:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* unused harmony export useTotalSupply */
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var _pancakeswap_sdk__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(82125);
/* harmony import */ var _useContract__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(93146);
/* harmony import */ var _state_multicall_hooks__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(410);




// returns undefined if input token is undefined, or fails to get token contract,
// or contract total supply cannot be fetched
function useTotalSupply(token) {
    var ref, ref1, ref2;
    var contract = (0,_useContract__WEBPACK_IMPORTED_MODULE_2__/* .useTokenContract */ .Ib)((token === null || token === void 0 ? void 0 : token.isToken) ? token.address : undefined, false);
    var totalSupplyStr = (ref = (0,_state_multicall_hooks__WEBPACK_IMPORTED_MODULE_3__/* .useSingleCallResult */ .Wk)(contract, "totalSupply")) === null || ref === void 0 ? void 0 : (ref1 = ref.result) === null || ref1 === void 0 ? void 0 : (ref2 = ref1[0]) === null || ref2 === void 0 ? void 0 : ref2.toString();
    return (0,react__WEBPACK_IMPORTED_MODULE_0__.useMemo)(function() {
        return (token === null || token === void 0 ? void 0 : token.isToken) && totalSupplyStr ? _pancakeswap_sdk__WEBPACK_IMPORTED_MODULE_1__/* .CurrencyAmount.fromRawAmount */ .ih.fromRawAmount(token, totalSupplyStr) : undefined;
    }, [
        token,
        totalSupplyStr
    ]);
}
/* harmony default export */ __webpack_exports__["Z"] = (useTotalSupply);


/***/ }),

/***/ 50192:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "OA": function() { return /* binding */ useMintActionHandlers; },
/* harmony export */   "OY": function() { return /* binding */ useMintState; },
/* harmony export */   "Qw": function() { return /* binding */ useDerivedMintInfo; },
/* harmony export */   "eM": function() { return /* binding */ useZapIn; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_20__ = __webpack_require__(14924);
/* harmony import */ var _swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_21__ = __webpack_require__(10253);
/* harmony import */ var _ethersproject_bignumber__WEBPACK_IMPORTED_MODULE_23__ = __webpack_require__(2593);
/* harmony import */ var _ethersproject_units__WEBPACK_IMPORTED_MODULE_22__ = __webpack_require__(61744);
/* harmony import */ var _pancakeswap_localization__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(52775);
/* harmony import */ var _pancakeswap_sdk__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(82125);
/* harmony import */ var config_constants_exchange__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(56974);
/* harmony import */ var config_constants_types__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(75759);
/* harmony import */ var hooks_Trades__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(94293);
/* harmony import */ var hooks_useActiveWeb3React__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(97477);
/* harmony import */ var hooks_useContract__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(93146);
/* harmony import */ var hooks_useNativeCurrency__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(19915);
/* harmony import */ var hooks_usePairs__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(71633);
/* harmony import */ var _pancakeswap_hooks__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(74903);
/* harmony import */ var hooks_useSWRContract__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(22408);
/* harmony import */ var hooks_useTotalSupply__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(19639);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(67294);
/* harmony import */ var react_redux__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(9473);
/* harmony import */ var state_user_hooks__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(921);
/* harmony import */ var utils_exchange__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(17937);
/* harmony import */ var _pancakeswap_utils_tryParseAmount__WEBPACK_IMPORTED_MODULE_16__ = __webpack_require__(68492);
/* harmony import */ var _index__WEBPACK_IMPORTED_MODULE_17__ = __webpack_require__(88453);
/* harmony import */ var _wallet_hooks__WEBPACK_IMPORTED_MODULE_18__ = __webpack_require__(5460);
/* harmony import */ var _actions__WEBPACK_IMPORTED_MODULE_19__ = __webpack_require__(21568);
























function useMintState() {
    return (0,react_redux__WEBPACK_IMPORTED_MODULE_13__/* .useSelector */ .v9)(function(state) {
        return state.mint;
    });
}
function useMintActionHandlers(noLiquidity) {
    var dispatch = (0,_index__WEBPACK_IMPORTED_MODULE_17__/* .useAppDispatch */ .TL)();
    var onFieldAInput = (0,react__WEBPACK_IMPORTED_MODULE_12__.useCallback)(function(typedValue) {
        dispatch((0,_actions__WEBPACK_IMPORTED_MODULE_19__/* .typeInput */ .LC)({
            field: _actions__WEBPACK_IMPORTED_MODULE_19__/* .Field.CURRENCY_A */ .gN.CURRENCY_A,
            typedValue: typedValue,
            noLiquidity: noLiquidity === true
        }));
    }, [
        dispatch,
        noLiquidity
    ]);
    var onFieldBInput = (0,react__WEBPACK_IMPORTED_MODULE_12__.useCallback)(function(typedValue) {
        dispatch((0,_actions__WEBPACK_IMPORTED_MODULE_19__/* .typeInput */ .LC)({
            field: _actions__WEBPACK_IMPORTED_MODULE_19__/* .Field.CURRENCY_B */ .gN.CURRENCY_B,
            typedValue: typedValue,
            noLiquidity: noLiquidity === true
        }));
    }, [
        dispatch,
        noLiquidity
    ]);
    return {
        onFieldAInput: onFieldAInput,
        onFieldBInput: onFieldBInput
    };
}
function useDerivedMintInfo(currencyA, currencyB) {
    var ref, ref1, ref2, ref3;
    var account = (0,hooks_useActiveWeb3React__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)().account;
    var t = (0,_pancakeswap_localization__WEBPACK_IMPORTED_MODULE_0__/* .useTranslation */ .$G)().t;
    var ref4 = useMintState(), independentField = ref4.independentField, typedValue = ref4.typedValue, otherTypedValue = ref4.otherTypedValue;
    var dependentField = independentField === _actions__WEBPACK_IMPORTED_MODULE_19__/* .Field.CURRENCY_A */ .gN.CURRENCY_A ? _actions__WEBPACK_IMPORTED_MODULE_19__/* .Field.CURRENCY_B */ .gN.CURRENCY_B : _actions__WEBPACK_IMPORTED_MODULE_19__/* .Field.CURRENCY_A */ .gN.CURRENCY_A;
    // tokens
    var currencies = (0,react__WEBPACK_IMPORTED_MODULE_12__.useMemo)(function() {
        var _obj;
        return _obj = {}, (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_20__/* ["default"] */ .Z)(_obj, _actions__WEBPACK_IMPORTED_MODULE_19__/* .Field.CURRENCY_A */ .gN.CURRENCY_A, currencyA !== null && currencyA !== void 0 ? currencyA : undefined), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_20__/* ["default"] */ .Z)(_obj, _actions__WEBPACK_IMPORTED_MODULE_19__/* .Field.CURRENCY_B */ .gN.CURRENCY_B, currencyB !== null && currencyB !== void 0 ? currencyB : undefined), _obj;
    }, [
        currencyA,
        currencyB
    ]);
    // pair
    var ref5 = (0,_swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_21__/* ["default"] */ .Z)((0,hooks_usePairs__WEBPACK_IMPORTED_MODULE_8__/* .usePair */ .yX)(currencies[_actions__WEBPACK_IMPORTED_MODULE_19__/* .Field.CURRENCY_A */ .gN.CURRENCY_A], currencies[_actions__WEBPACK_IMPORTED_MODULE_19__/* .Field.CURRENCY_B */ .gN.CURRENCY_B]), 2), pairState = ref5[0], pair = ref5[1];
    var totalSupply = (0,hooks_useTotalSupply__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z)(pair === null || pair === void 0 ? void 0 : pair.liquidityToken);
    var noLiquidity = pairState === hooks_usePairs__WEBPACK_IMPORTED_MODULE_8__/* .PairState.NOT_EXISTS */ ._G.NOT_EXISTS || Boolean(totalSupply && _pancakeswap_sdk__WEBPACK_IMPORTED_MODULE_1__/* .JSBI.equal */ .QA.equal(totalSupply.quotient, config_constants_exchange__WEBPACK_IMPORTED_MODULE_2__/* .BIG_INT_ZERO */ .iV)) || Boolean(pairState === hooks_usePairs__WEBPACK_IMPORTED_MODULE_8__/* .PairState.EXISTS */ ._G.EXISTS && pair && _pancakeswap_sdk__WEBPACK_IMPORTED_MODULE_1__/* .JSBI.equal */ .QA.equal(pair.reserve0.quotient, config_constants_exchange__WEBPACK_IMPORTED_MODULE_2__/* .BIG_INT_ZERO */ .iV) && _pancakeswap_sdk__WEBPACK_IMPORTED_MODULE_1__/* .JSBI.equal */ .QA.equal(pair.reserve1.quotient, config_constants_exchange__WEBPACK_IMPORTED_MODULE_2__/* .BIG_INT_ZERO */ .iV));
    // balances
    var balances = (0,_wallet_hooks__WEBPACK_IMPORTED_MODULE_18__/* .useCurrencyBalances */ .K5)(account !== null && account !== void 0 ? account : undefined, [
        currencies[_actions__WEBPACK_IMPORTED_MODULE_19__/* .Field.CURRENCY_A */ .gN.CURRENCY_A],
        currencies[_actions__WEBPACK_IMPORTED_MODULE_19__/* .Field.CURRENCY_B */ .gN.CURRENCY_B], 
    ]);
    var _obj;
    var currencyBalances = (_obj = {}, (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_20__/* ["default"] */ .Z)(_obj, _actions__WEBPACK_IMPORTED_MODULE_19__/* .Field.CURRENCY_A */ .gN.CURRENCY_A, balances[0]), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_20__/* ["default"] */ .Z)(_obj, _actions__WEBPACK_IMPORTED_MODULE_19__/* .Field.CURRENCY_B */ .gN.CURRENCY_B, balances[1]), _obj);
    // amounts
    var independentAmount = (0,_pancakeswap_utils_tryParseAmount__WEBPACK_IMPORTED_MODULE_16__/* ["default"] */ .Z)(typedValue, currencies[independentField]);
    var dependentAmount = (0,react__WEBPACK_IMPORTED_MODULE_12__.useMemo)(function() {
        if (noLiquidity) {
            if (otherTypedValue && currencies[dependentField]) {
                return (0,_pancakeswap_utils_tryParseAmount__WEBPACK_IMPORTED_MODULE_16__/* ["default"] */ .Z)(otherTypedValue, currencies[dependentField]);
            }
            return undefined;
        }
        if (independentAmount) {
            // we wrap the currencies just to get the price in terms of the other token
            var wrappedIndependentAmount = independentAmount === null || independentAmount === void 0 ? void 0 : independentAmount.wrapped;
            var ref = [
                currencyA === null || currencyA === void 0 ? void 0 : currencyA.wrapped,
                currencyB === null || currencyB === void 0 ? void 0 : currencyB.wrapped
            ], tokenA = ref[0], tokenB = ref[1];
            if (tokenA && tokenB && wrappedIndependentAmount && pair) {
                var dependentCurrency = dependentField === _actions__WEBPACK_IMPORTED_MODULE_19__/* .Field.CURRENCY_B */ .gN.CURRENCY_B ? currencyB : currencyA;
                var dependentTokenAmount = dependentField === _actions__WEBPACK_IMPORTED_MODULE_19__/* .Field.CURRENCY_B */ .gN.CURRENCY_B ? pair.priceOf(tokenA).quote(wrappedIndependentAmount) : pair.priceOf(tokenB).quote(wrappedIndependentAmount);
                return (dependentCurrency === null || dependentCurrency === void 0 ? void 0 : dependentCurrency.isNative) ? _pancakeswap_sdk__WEBPACK_IMPORTED_MODULE_1__/* .CurrencyAmount.fromRawAmount */ .ih.fromRawAmount(dependentCurrency, dependentTokenAmount.quotient) : dependentTokenAmount;
            }
            return undefined;
        }
        return undefined;
    }, [
        noLiquidity,
        otherTypedValue,
        currencies,
        dependentField,
        independentAmount,
        currencyA,
        currencyB,
        pair
    ]);
    var parsedAmounts = (0,react__WEBPACK_IMPORTED_MODULE_12__.useMemo)(function() {
        var _obj;
        return _obj = {}, (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_20__/* ["default"] */ .Z)(_obj, _actions__WEBPACK_IMPORTED_MODULE_19__/* .Field.CURRENCY_A */ .gN.CURRENCY_A, independentField === _actions__WEBPACK_IMPORTED_MODULE_19__/* .Field.CURRENCY_A */ .gN.CURRENCY_A ? independentAmount : dependentAmount), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_20__/* ["default"] */ .Z)(_obj, _actions__WEBPACK_IMPORTED_MODULE_19__/* .Field.CURRENCY_B */ .gN.CURRENCY_B, independentField === _actions__WEBPACK_IMPORTED_MODULE_19__/* .Field.CURRENCY_A */ .gN.CURRENCY_A ? dependentAmount : independentAmount), _obj;
    }, [
        dependentAmount,
        independentAmount,
        independentField
    ]);
    var price = (0,react__WEBPACK_IMPORTED_MODULE_12__.useMemo)(function() {
        if (noLiquidity) {
            var currencyAAmount = parsedAmounts[_actions__WEBPACK_IMPORTED_MODULE_19__/* .Field.CURRENCY_A */ .gN.CURRENCY_A], currencyBAmount = parsedAmounts[_actions__WEBPACK_IMPORTED_MODULE_19__/* .Field.CURRENCY_B */ .gN.CURRENCY_B];
            if (currencyAAmount && currencyBAmount) {
                return new _pancakeswap_sdk__WEBPACK_IMPORTED_MODULE_1__/* .Price */ .tA(currencyAAmount.currency, currencyBAmount.currency, currencyAAmount.quotient, currencyBAmount.quotient);
            }
            return undefined;
        }
        var wrappedCurrencyA = currencyA === null || currencyA === void 0 ? void 0 : currencyA.wrapped;
        return pair && wrappedCurrencyA ? pair.priceOf(wrappedCurrencyA) : undefined;
    }, [
        currencyA,
        noLiquidity,
        pair,
        parsedAmounts
    ]);
    // liquidity minted
    var liquidityMinted = (0,react__WEBPACK_IMPORTED_MODULE_12__.useMemo)(function() {
        var currencyAAmount = parsedAmounts[_actions__WEBPACK_IMPORTED_MODULE_19__/* .Field.CURRENCY_A */ .gN.CURRENCY_A], currencyBAmount = parsedAmounts[_actions__WEBPACK_IMPORTED_MODULE_19__/* .Field.CURRENCY_B */ .gN.CURRENCY_B];
        var ref = [
            currencyAAmount === null || currencyAAmount === void 0 ? void 0 : currencyAAmount.wrapped,
            currencyBAmount === null || currencyBAmount === void 0 ? void 0 : currencyBAmount.wrapped
        ], tokenAmountA = ref[0], tokenAmountB = ref[1];
        if (pair && totalSupply && tokenAmountA && tokenAmountB) {
            try {
                return pair.getLiquidityMinted(totalSupply, tokenAmountA, tokenAmountB);
            } catch (error) {
                console.error(error);
                return undefined;
            }
        }
        return undefined;
    }, [
        parsedAmounts,
        pair,
        totalSupply
    ]);
    var poolTokenPercentage = (0,react__WEBPACK_IMPORTED_MODULE_12__.useMemo)(function() {
        if (liquidityMinted && totalSupply) {
            return new _pancakeswap_sdk__WEBPACK_IMPORTED_MODULE_1__/* .Percent */ .gG(liquidityMinted.quotient, totalSupply.add(liquidityMinted).quotient);
        }
        return undefined;
    }, [
        liquidityMinted,
        totalSupply
    ]);
    var error;
    var addError;
    if (!account) {
        error = t("Connect Wallet");
    }
    if (pairState === hooks_usePairs__WEBPACK_IMPORTED_MODULE_8__/* .PairState.INVALID */ ._G.INVALID) {
        error = error !== null && error !== void 0 ? error : t("Choose a valid pair");
    }
    var currencyAAmount = parsedAmounts[_actions__WEBPACK_IMPORTED_MODULE_19__/* .Field.CURRENCY_A */ .gN.CURRENCY_A], currencyBAmount = parsedAmounts[_actions__WEBPACK_IMPORTED_MODULE_19__/* .Field.CURRENCY_B */ .gN.CURRENCY_B];
    if (currencyAAmount && currencyBAmount && (currencyBalances === null || currencyBalances === void 0 ? void 0 : (ref = currencyBalances[_actions__WEBPACK_IMPORTED_MODULE_19__/* .Field.CURRENCY_A */ .gN.CURRENCY_A]) === null || ref === void 0 ? void 0 : ref.equalTo(0)) && (currencyBalances === null || currencyBalances === void 0 ? void 0 : (ref1 = currencyBalances[_actions__WEBPACK_IMPORTED_MODULE_19__/* .Field.CURRENCY_B */ .gN.CURRENCY_B]) === null || ref1 === void 0 ? void 0 : ref1.equalTo(0))) {
        error = error !== null && error !== void 0 ? error : t("No token balance");
    }
    if (!parsedAmounts[_actions__WEBPACK_IMPORTED_MODULE_19__/* .Field.CURRENCY_A */ .gN.CURRENCY_A] || !parsedAmounts[_actions__WEBPACK_IMPORTED_MODULE_19__/* .Field.CURRENCY_B */ .gN.CURRENCY_B]) {
        addError = t("Enter an amount");
    }
    if (currencyAAmount && (currencyBalances === null || currencyBalances === void 0 ? void 0 : (ref2 = currencyBalances[_actions__WEBPACK_IMPORTED_MODULE_19__/* .Field.CURRENCY_A */ .gN.CURRENCY_A]) === null || ref2 === void 0 ? void 0 : ref2.lessThan(currencyAAmount))) {
        var ref6;
        addError = t("Insufficient %symbol% balance", {
            symbol: (ref6 = currencies[_actions__WEBPACK_IMPORTED_MODULE_19__/* .Field.CURRENCY_A */ .gN.CURRENCY_A]) === null || ref6 === void 0 ? void 0 : ref6.symbol
        });
    }
    if (currencyBAmount && (currencyBalances === null || currencyBalances === void 0 ? void 0 : (ref3 = currencyBalances[_actions__WEBPACK_IMPORTED_MODULE_19__/* .Field.CURRENCY_B */ .gN.CURRENCY_B]) === null || ref3 === void 0 ? void 0 : ref3.lessThan(currencyBAmount))) {
        var ref7;
        addError = t("Insufficient %symbol% balance", {
            symbol: (ref7 = currencies[_actions__WEBPACK_IMPORTED_MODULE_19__/* .Field.CURRENCY_B */ .gN.CURRENCY_B]) === null || ref7 === void 0 ? void 0 : ref7.symbol
        });
    }
    return {
        dependentField: dependentField,
        currencies: currencies,
        pair: pair,
        pairState: pairState,
        currencyBalances: currencyBalances,
        parsedAmounts: parsedAmounts,
        price: price,
        noLiquidity: noLiquidity,
        liquidityMinted: liquidityMinted,
        poolTokenPercentage: poolTokenPercentage,
        error: error,
        addError: addError
    };
}
var MAX_ZAP_REVERSE_RATIO = _pancakeswap_sdk__WEBPACK_IMPORTED_MODULE_1__/* .JSBI.BigInt */ .QA.BigInt(50);
var getMaxZapSwapAmount = function(pair, tokenZap) {
    return pair && tokenZap && pair.involvesToken(tokenZap) && _pancakeswap_sdk__WEBPACK_IMPORTED_MODULE_1__/* .JSBI.divide */ .QA.divide(pair.reserveOf(tokenZap).quotient, MAX_ZAP_REVERSE_RATIO);
};
// simplify version to guess the zap in amount by swapInAmount from max zap reserves ratio 50
function guessMaxZappableAmount(pair, token0AmountIn, token1AmountIn) {
    if (!token1AmountIn) {
        if (token0AmountIn) {
            var maxSwapAmount = getMaxZapSwapAmount(pair, token0AmountIn.currency);
            return maxSwapAmount && _pancakeswap_sdk__WEBPACK_IMPORTED_MODULE_1__/* .JSBI.multiply */ .QA.multiply(maxSwapAmount, _pancakeswap_sdk__WEBPACK_IMPORTED_MODULE_1__/* .JSBI.BigInt */ .QA.BigInt(2));
        }
        return undefined;
    }
    if (token0AmountIn && token1AmountIn) {
        var maxSwapAmount1 = getMaxZapSwapAmount(pair, token0AmountIn.currency);
        if (!maxSwapAmount1) {
            return undefined;
        }
        var ref = (0,_swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_21__/* ["default"] */ .Z)(pair.getInputAmount(_pancakeswap_sdk__WEBPACK_IMPORTED_MODULE_1__/* .CurrencyAmount.fromRawAmount */ .ih.fromRawAmount(token0AmountIn.currency, maxSwapAmount1)), 2), _ = ref[0], newPair = ref[1];
        return _pancakeswap_sdk__WEBPACK_IMPORTED_MODULE_1__/* .JSBI.add */ .QA.add(maxSwapAmount1, _pancakeswap_sdk__WEBPACK_IMPORTED_MODULE_1__/* .JSBI.divide */ .QA.divide(_pancakeswap_sdk__WEBPACK_IMPORTED_MODULE_1__/* .JSBI.multiply */ .QA.multiply(token1AmountIn.quotient, newPair.reserveOf(token0AmountIn.currency).quotient), newPair.reserveOf(token1AmountIn.currency).quotient));
    }
    return undefined;
}
// compare the gas is larger than swap in amount
function useZapInGasOverhead(inputAmount) {
    var ref;
    var gasPrice = (0,state_user_hooks__WEBPACK_IMPORTED_MODULE_14__/* .useGasPrice */ .Fh)();
    var native = (0,hooks_useNativeCurrency__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)();
    var requiredGas = (0,_ethersproject_units__WEBPACK_IMPORTED_MODULE_22__.formatUnits)(gasPrice ? _ethersproject_bignumber__WEBPACK_IMPORTED_MODULE_23__/* .BigNumber.from */ .O$.from(gasPrice).mul("500000") : "0");
    var requiredGasAsCurrencyAmount = inputAmount ? (0,_pancakeswap_utils_tryParseAmount__WEBPACK_IMPORTED_MODULE_16__/* ["default"] */ .Z)(requiredGas, native) : undefined;
    var inputIsBNB = (inputAmount === null || inputAmount === void 0 ? void 0 : inputAmount.currency.symbol) === "BNB";
    var gasCostInInputTokens = (0,hooks_Trades__WEBPACK_IMPORTED_MODULE_4__/* .useTradeExactIn */ .AU)(requiredGasAsCurrencyAmount, inputIsBNB ? null : inputAmount === null || inputAmount === void 0 ? void 0 : inputAmount.currency);
    var ref1;
    return (ref1 = gasCostInInputTokens === null || gasCostInInputTokens === void 0 ? void 0 : (ref = gasCostInInputTokens.outputAmount) === null || ref === void 0 ? void 0 : ref.greaterThan(inputAmount === null || inputAmount === void 0 ? void 0 : inputAmount.quotient)) !== null && ref1 !== void 0 ? ref1 : false;
}
function useZapIn(param) {
    var canZap = param.canZap, currencyA = param.currencyA, currencyB = param.currencyB, pair = param.pair, currencyBalances = param.currencyBalances, zapTokenCheckedA = param.zapTokenCheckedA, zapTokenCheckedB = param.zapTokenCheckedB, maxAmounts = param.maxAmounts;
    var ref, ref1, ref2, ref3;
    var t = (0,_pancakeswap_localization__WEBPACK_IMPORTED_MODULE_0__/* .useTranslation */ .$G)().t;
    var ref4 = (0,react__WEBPACK_IMPORTED_MODULE_12__.useState)(false), inputBlurOnce = ref4[0], setInputBlurOnce = ref4[1];
    var previousBlur = (0,_pancakeswap_hooks__WEBPACK_IMPORTED_MODULE_9__/* .usePreviousValue */ .zP)(inputBlurOnce);
    var ref5 = (0,react__WEBPACK_IMPORTED_MODULE_12__.useState)(false), triedAutoReduce = ref5[0], setTriedAutoReduce = ref5[1];
    var ref6 = useMintState(), independentField = ref6.independentField, typedValue = ref6.typedValue;
    var dependentField = independentField === _actions__WEBPACK_IMPORTED_MODULE_19__/* .Field.CURRENCY_A */ .gN.CURRENCY_A ? _actions__WEBPACK_IMPORTED_MODULE_19__/* .Field.CURRENCY_B */ .gN.CURRENCY_B : _actions__WEBPACK_IMPORTED_MODULE_19__/* .Field.CURRENCY_A */ .gN.CURRENCY_A;
    var currencies = (0,react__WEBPACK_IMPORTED_MODULE_12__.useMemo)(function() {
        var _obj;
        return _obj = {}, (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_20__/* ["default"] */ .Z)(_obj, _actions__WEBPACK_IMPORTED_MODULE_19__/* .Field.CURRENCY_A */ .gN.CURRENCY_A, currencyA !== null && currencyA !== void 0 ? currencyA : undefined), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_20__/* ["default"] */ .Z)(_obj, _actions__WEBPACK_IMPORTED_MODULE_19__/* .Field.CURRENCY_B */ .gN.CURRENCY_B, currencyB !== null && currencyB !== void 0 ? currencyB : undefined), _obj;
    }, [
        currencyA,
        currencyB
    ]);
    var independentAmount = (0,_pancakeswap_utils_tryParseAmount__WEBPACK_IMPORTED_MODULE_16__/* ["default"] */ .Z)(typedValue, currencies[independentField]);
    var _dependentAmount = (0,react__WEBPACK_IMPORTED_MODULE_12__.useMemo)(function() {
        if (!canZap) {
            return undefined;
        }
        if (independentAmount) {
            var wrappedIndependentAmount = independentAmount === null || independentAmount === void 0 ? void 0 : independentAmount.wrapped;
            var ref = [
                currencyA === null || currencyA === void 0 ? void 0 : currencyA.wrapped,
                currencyB === null || currencyB === void 0 ? void 0 : currencyB.wrapped
            ], tokenA = ref[0], tokenB = ref[1];
            if (tokenA && tokenB && wrappedIndependentAmount && pair) {
                var dependentCurrency = dependentField === _actions__WEBPACK_IMPORTED_MODULE_19__/* .Field.CURRENCY_B */ .gN.CURRENCY_B ? currencyB : currencyA;
                var dependentTokenAmount = dependentField === _actions__WEBPACK_IMPORTED_MODULE_19__/* .Field.CURRENCY_B */ .gN.CURRENCY_B ? pair.priceOf(tokenA).quote(wrappedIndependentAmount) : pair.priceOf(tokenB).quote(wrappedIndependentAmount);
                return dependentCurrency.isNative ? _pancakeswap_sdk__WEBPACK_IMPORTED_MODULE_1__/* .CurrencyAmount.fromRawAmount */ .ih.fromRawAmount(dependentCurrency, dependentTokenAmount.quotient) : dependentTokenAmount;
            }
            return undefined;
        }
        return undefined;
    }, [
        canZap,
        currencyA,
        currencyB,
        dependentField,
        independentAmount,
        pair
    ]);
    var isDependentAmountGreaterThanMaxAmount = maxAmounts[dependentField] && _dependentAmount && (_dependentAmount === null || _dependentAmount === void 0 ? void 0 : _dependentAmount.greaterThan(maxAmounts[dependentField]));
    // amounts
    var dependentAmount = (0,react__WEBPACK_IMPORTED_MODULE_12__.useMemo)(function() {
        return isDependentAmountGreaterThanMaxAmount ? maxAmounts[dependentField] : _dependentAmount;
    }, [
        isDependentAmountGreaterThanMaxAmount,
        maxAmounts,
        dependentField,
        _dependentAmount
    ]);
    var parsedAmounts = (0,react__WEBPACK_IMPORTED_MODULE_12__.useMemo)(function() {
        var _obj;
        return _obj = {}, (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_20__/* ["default"] */ .Z)(_obj, _actions__WEBPACK_IMPORTED_MODULE_19__/* .Field.CURRENCY_A */ .gN.CURRENCY_A, !zapTokenCheckedA ? undefined : independentField === _actions__WEBPACK_IMPORTED_MODULE_19__/* .Field.CURRENCY_A */ .gN.CURRENCY_A ? independentAmount : dependentAmount), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_20__/* ["default"] */ .Z)(_obj, _actions__WEBPACK_IMPORTED_MODULE_19__/* .Field.CURRENCY_B */ .gN.CURRENCY_B, !zapTokenCheckedB ? undefined : independentField === _actions__WEBPACK_IMPORTED_MODULE_19__/* .Field.CURRENCY_A */ .gN.CURRENCY_A ? dependentAmount : independentAmount), _obj;
    }, [
        dependentAmount,
        independentAmount,
        independentField,
        zapTokenCheckedA,
        zapTokenCheckedB
    ]);
    var wrappedParsedAmounts = (0,react__WEBPACK_IMPORTED_MODULE_12__.useMemo)(function() {
        var ref, ref1;
        var _obj;
        return _obj = {}, (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_20__/* ["default"] */ .Z)(_obj, _actions__WEBPACK_IMPORTED_MODULE_19__/* .Field.CURRENCY_A */ .gN.CURRENCY_A, (ref = parsedAmounts[_actions__WEBPACK_IMPORTED_MODULE_19__/* .Field.CURRENCY_A */ .gN.CURRENCY_A]) === null || ref === void 0 ? void 0 : ref.wrapped), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_20__/* ["default"] */ .Z)(_obj, _actions__WEBPACK_IMPORTED_MODULE_19__/* .Field.CURRENCY_B */ .gN.CURRENCY_B, (ref1 = parsedAmounts[_actions__WEBPACK_IMPORTED_MODULE_19__/* .Field.CURRENCY_B */ .gN.CURRENCY_B]) === null || ref1 === void 0 ? void 0 : ref1.wrapped), _obj;
    }, [
        parsedAmounts
    ]);
    var zapContract = (0,hooks_useContract__WEBPACK_IMPORTED_MODULE_6__/* .useZapContract */ .n9)();
    var rebalancing = !!zapTokenCheckedA && !!zapTokenCheckedB && !!parsedAmounts[_actions__WEBPACK_IMPORTED_MODULE_19__/* .Field.CURRENCY_A */ .gN.CURRENCY_A] && !!parsedAmounts[_actions__WEBPACK_IMPORTED_MODULE_19__/* .Field.CURRENCY_B */ .gN.CURRENCY_B];
    var singleTokenToZapField = !rebalancing && zapTokenCheckedB && !!parsedAmounts[_actions__WEBPACK_IMPORTED_MODULE_19__/* .Field.CURRENCY_B */ .gN.CURRENCY_B] ? _actions__WEBPACK_IMPORTED_MODULE_19__/* .Field.CURRENCY_B */ .gN.CURRENCY_B : _actions__WEBPACK_IMPORTED_MODULE_19__/* .Field.CURRENCY_A */ .gN.CURRENCY_A;
    var singleTokenToZapAmount = (0,react__WEBPACK_IMPORTED_MODULE_12__.useMemo)(function() {
        return wrappedParsedAmounts[singleTokenToZapField];
    }, [
        singleTokenToZapField,
        wrappedParsedAmounts
    ]);
    var noNeedZap = (0,react__WEBPACK_IMPORTED_MODULE_12__.useMemo)(function() {
        if (!rebalancing) {
            return false;
        }
        if (!wrappedParsedAmounts[independentField] || !wrappedParsedAmounts[dependentField]) {
            return undefined;
        }
        if (!isDependentAmountGreaterThanMaxAmount) {
            return true;
        }
        var ref = [
            currencyA === null || currencyA === void 0 ? void 0 : currencyA.wrapped,
            currencyB === null || currencyB === void 0 ? void 0 : currencyB.wrapped
        ], tokenA = ref[0], tokenB = ref[1];
        if (tokenA && tokenB && wrappedParsedAmounts[independentField] && pair) {
            return wrappedParsedAmounts[dependentField].equalTo(dependentField === _actions__WEBPACK_IMPORTED_MODULE_19__/* .Field.CURRENCY_B */ .gN.CURRENCY_B ? pair.priceOf(tokenA).quote(wrappedParsedAmounts[independentField]) : pair.priceOf(tokenB).quote(wrappedParsedAmounts[independentField]));
        }
        return undefined;
    }, [
        currencyA,
        currencyB,
        dependentField,
        independentField,
        isDependentAmountGreaterThanMaxAmount,
        pair,
        rebalancing,
        wrappedParsedAmounts, 
    ]);
    var singleZapEstimate = (0,hooks_useSWRContract__WEBPACK_IMPORTED_MODULE_10__/* .useSWRContract */ .Av)(canZap && !noNeedZap && zapContract && singleTokenToZapAmount && (singleTokenToZapAmount === null || singleTokenToZapAmount === void 0 ? void 0 : singleTokenToZapAmount.currency) && pair && !rebalancing && {
        contract: zapContract,
        methodName: "estimateZapInSwap",
        params: [
            singleTokenToZapAmount.currency.address,
            singleTokenToZapAmount.quotient.toString(),
            pair.liquidityToken.address, 
        ]
    }, {
        onError: function onError(err) {
            console.error(err);
        }
    });
    var rebalancingZapEstimate = (0,hooks_useSWRContract__WEBPACK_IMPORTED_MODULE_10__/* .useSWRContract */ .Av)(canZap && zapContract && !noNeedZap && wrappedParsedAmounts && wrappedParsedAmounts[_actions__WEBPACK_IMPORTED_MODULE_19__/* .Field.CURRENCY_A */ .gN.CURRENCY_A] && wrappedParsedAmounts[_actions__WEBPACK_IMPORTED_MODULE_19__/* .Field.CURRENCY_B */ .gN.CURRENCY_B] && pair && rebalancing && {
        contract: zapContract,
        methodName: "estimateZapInRebalancingSwap",
        params: [
            wrappedParsedAmounts[_actions__WEBPACK_IMPORTED_MODULE_19__/* .Field.CURRENCY_A */ .gN.CURRENCY_A].currency.address,
            wrappedParsedAmounts[_actions__WEBPACK_IMPORTED_MODULE_19__/* .Field.CURRENCY_B */ .gN.CURRENCY_B].currency.address,
            wrappedParsedAmounts[_actions__WEBPACK_IMPORTED_MODULE_19__/* .Field.CURRENCY_A */ .gN.CURRENCY_A].quotient.toString(),
            (ref = wrappedParsedAmounts[_actions__WEBPACK_IMPORTED_MODULE_19__/* .Field.CURRENCY_B */ .gN.CURRENCY_B]) === null || ref === void 0 ? void 0 : (ref1 = ref.quotient) === null || ref1 === void 0 ? void 0 : ref1.toString(),
            pair.liquidityToken.address, 
        ]
    }, {
        onError: function onError(err) {
            console.error(err);
        }
    });
    var zapInEstimated = (0,react__WEBPACK_IMPORTED_MODULE_12__.useMemo)(function() {
        var ref, ref1, ref2, ref3, ref4, ref5;
        return ((rebalancingZapEstimate === null || rebalancingZapEstimate === void 0 ? void 0 : rebalancingZapEstimate.data) || (singleZapEstimate === null || singleZapEstimate === void 0 ? void 0 : singleZapEstimate.data)) && {
            swapAmountIn: rebalancing ? (ref = rebalancingZapEstimate.data) === null || ref === void 0 ? void 0 : ref.swapAmountIn : (ref1 = singleZapEstimate.data) === null || ref1 === void 0 ? void 0 : ref1.swapAmountIn,
            swapAmountOut: rebalancing ? (ref2 = rebalancingZapEstimate.data) === null || ref2 === void 0 ? void 0 : ref2.swapAmountOut : (ref3 = singleZapEstimate.data) === null || ref3 === void 0 ? void 0 : ref3.swapAmountOut,
            isToken0Sold: rebalancing ? (ref4 = rebalancingZapEstimate.data) === null || ref4 === void 0 ? void 0 : ref4.sellToken0 : ((ref5 = singleZapEstimate.data) === null || ref5 === void 0 ? void 0 : ref5.swapTokenOut) === (singleTokenToZapAmount === null || singleTokenToZapAmount === void 0 ? void 0 : singleTokenToZapAmount.currency.address)
        };
    }, [
        rebalancing,
        rebalancingZapEstimate.data,
        singleZapEstimate.data,
        singleTokenToZapAmount === null || singleTokenToZapAmount === void 0 ? void 0 : singleTokenToZapAmount.currency.address
    ]);
    var rebalancingSellToken0 = (0,react__WEBPACK_IMPORTED_MODULE_12__.useMemo)(function() {
        if (rebalancingZapEstimate.data) {
            return rebalancingZapEstimate.data.sellToken0;
        }
        if (!pair || !wrappedParsedAmounts[_actions__WEBPACK_IMPORTED_MODULE_19__/* .Field.CURRENCY_A */ .gN.CURRENCY_A] || !wrappedParsedAmounts[_actions__WEBPACK_IMPORTED_MODULE_19__/* .Field.CURRENCY_B */ .gN.CURRENCY_B]) {
            return undefined;
        }
        var token0toZap = pair.token0.equals(wrappedParsedAmounts[_actions__WEBPACK_IMPORTED_MODULE_19__/* .Field.CURRENCY_A */ .gN.CURRENCY_A].currency);
        if (token0toZap) {
            return _pancakeswap_sdk__WEBPACK_IMPORTED_MODULE_1__/* .JSBI.greaterThan */ .QA.greaterThan(_pancakeswap_sdk__WEBPACK_IMPORTED_MODULE_1__/* .JSBI.multiply */ .QA.multiply(wrappedParsedAmounts[_actions__WEBPACK_IMPORTED_MODULE_19__/* .Field.CURRENCY_A */ .gN.CURRENCY_A].quotient, pair.reserve1.quotient), _pancakeswap_sdk__WEBPACK_IMPORTED_MODULE_1__/* .JSBI.multiply */ .QA.multiply(wrappedParsedAmounts[_actions__WEBPACK_IMPORTED_MODULE_19__/* .Field.CURRENCY_B */ .gN.CURRENCY_B].quotient, pair.reserve0.quotient));
        }
        return _pancakeswap_sdk__WEBPACK_IMPORTED_MODULE_1__/* .JSBI.greaterThan */ .QA.greaterThan(_pancakeswap_sdk__WEBPACK_IMPORTED_MODULE_1__/* .JSBI.multiply */ .QA.multiply(wrappedParsedAmounts[_actions__WEBPACK_IMPORTED_MODULE_19__/* .Field.CURRENCY_B */ .gN.CURRENCY_B].quotient, pair.reserve0.quotient), _pancakeswap_sdk__WEBPACK_IMPORTED_MODULE_1__/* .JSBI.multiply */ .QA.multiply(wrappedParsedAmounts[_actions__WEBPACK_IMPORTED_MODULE_19__/* .Field.CURRENCY_A */ .gN.CURRENCY_A].quotient, pair.reserve1.quotient));
    }, [
        pair,
        rebalancingZapEstimate.data,
        wrappedParsedAmounts
    ]);
    var swapTokenField = !rebalancing ? singleTokenToZapField : rebalancingSellToken0 ? _actions__WEBPACK_IMPORTED_MODULE_19__/* .Field.CURRENCY_A */ .gN.CURRENCY_A : _actions__WEBPACK_IMPORTED_MODULE_19__/* .Field.CURRENCY_B */ .gN.CURRENCY_B;
    var swapOutTokenField = swapTokenField === _actions__WEBPACK_IMPORTED_MODULE_19__/* .Field.CURRENCY_A */ .gN.CURRENCY_A ? _actions__WEBPACK_IMPORTED_MODULE_19__/* .Field.CURRENCY_B */ .gN.CURRENCY_B : _actions__WEBPACK_IMPORTED_MODULE_19__/* .Field.CURRENCY_A */ .gN.CURRENCY_A;
    var swapTokens = (0,react__WEBPACK_IMPORTED_MODULE_12__.useMemo)(function() {
        var ref, ref1;
        var _obj;
        return _obj = {}, (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_20__/* ["default"] */ .Z)(_obj, swapTokenField, (ref = currencies[swapTokenField]) === null || ref === void 0 ? void 0 : ref.wrapped), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_20__/* ["default"] */ .Z)(_obj, swapOutTokenField, (ref1 = currencies[swapOutTokenField]) === null || ref1 === void 0 ? void 0 : ref1.wrapped), _obj;
    }, [
        currencies,
        swapOutTokenField,
        swapTokenField
    ]);
    var zapInEstimatedError = (0,react__WEBPACK_IMPORTED_MODULE_12__.useMemo)(function() {
        return rebalancing ? rebalancingZapEstimate.error : singleZapEstimate.error;
    }, [
        rebalancing,
        rebalancingZapEstimate.error,
        singleZapEstimate.error
    ]);
    var zapInEstimatedStatus = (0,react__WEBPACK_IMPORTED_MODULE_12__.useMemo)(function() {
        return rebalancing ? rebalancingZapEstimate.status : singleZapEstimate.status;
    }, [
        rebalancing,
        rebalancingZapEstimate.status,
        singleZapEstimate.status
    ]);
    var priceImpact = (0,react__WEBPACK_IMPORTED_MODULE_12__.useMemo)(function() {
        if (!zapInEstimated) {
            return undefined;
        }
        var tokenAmountIn = _pancakeswap_sdk__WEBPACK_IMPORTED_MODULE_1__/* .CurrencyAmount.fromRawAmount */ .ih.fromRawAmount(swapTokens[swapTokenField], zapInEstimated.swapAmountIn.toString());
        var tokenAmountOut = _pancakeswap_sdk__WEBPACK_IMPORTED_MODULE_1__/* .CurrencyAmount.fromRawAmount */ .ih.fromRawAmount(swapTokens[swapOutTokenField], zapInEstimated.swapAmountOut.toString());
        var midPrice = new _pancakeswap_sdk__WEBPACK_IMPORTED_MODULE_1__/* .Price */ .tA(swapTokens[swapTokenField], swapTokens[swapOutTokenField], pair.token0.equals(swapTokens[swapTokenField]) ? pair.reserve0.quotient : pair.reserve1.quotient, pair.token0.equals(swapTokens[swapTokenField]) ? pair.reserve1.quotient : pair.reserve0.quotient);
        return (0,_pancakeswap_sdk__WEBPACK_IMPORTED_MODULE_1__/* .computePriceImpact */ .oc)(midPrice, tokenAmountIn, tokenAmountOut);
    }, [
        pair,
        swapOutTokenField,
        swapTokenField,
        swapTokens,
        zapInEstimated
    ]);
    var overLimitZapRatio = (0,react__WEBPACK_IMPORTED_MODULE_12__.useMemo)(function() {
        if (!zapInEstimated) {
            return false;
        }
        return _pancakeswap_sdk__WEBPACK_IMPORTED_MODULE_1__/* .JSBI.lessThan */ .QA.lessThan(_pancakeswap_sdk__WEBPACK_IMPORTED_MODULE_1__/* .JSBI.divide */ .QA.divide(pair.reserveOf(swapTokens[swapTokenField]).quotient, _pancakeswap_sdk__WEBPACK_IMPORTED_MODULE_1__/* .JSBI.BigInt */ .QA.BigInt(zapInEstimated.swapAmountIn.toString())), MAX_ZAP_REVERSE_RATIO);
    }, [
        pair,
        swapTokens,
        zapInEstimated,
        swapTokenField
    ]);
    var priceSeverity = overLimitZapRatio || zapInEstimatedError ? 4 : priceImpact ? (0,utils_exchange__WEBPACK_IMPORTED_MODULE_15__/* .warningSeverity */ .oX)(priceImpact) : 0;
    var ref7 = useMintActionHandlers(false), onFieldAInput = ref7.onFieldAInput, onFieldBInput = ref7.onFieldBInput;
    var maxZappableAmount = (0,react__WEBPACK_IMPORTED_MODULE_12__.useMemo)(function() {
        return guessMaxZappableAmount(pair, wrappedParsedAmounts[swapTokenField], rebalancing ? wrappedParsedAmounts[swapOutTokenField] : undefined);
    }, [
        pair,
        wrappedParsedAmounts,
        swapTokenField,
        rebalancing,
        swapOutTokenField
    ]);
    var convertToMaxZappable = (0,react__WEBPACK_IMPORTED_MODULE_12__.useCallback)(function() {
        if (maxZappableAmount) {
            if (maxAmounts[swapTokenField]) {
                var ref;
                var formatInput = (0,_ethersproject_units__WEBPACK_IMPORTED_MODULE_22__.formatUnits)(_pancakeswap_sdk__WEBPACK_IMPORTED_MODULE_1__/* .JSBI.greaterThan */ .QA.greaterThan(maxAmounts[swapTokenField].quotient, maxZappableAmount) ? maxZappableAmount.toString() : maxAmounts[swapTokenField].quotient.toString(), (ref = maxAmounts[swapTokenField]) === null || ref === void 0 ? void 0 : ref.currency.decimals);
                if (swapTokenField === _actions__WEBPACK_IMPORTED_MODULE_19__/* .Field.CURRENCY_A */ .gN.CURRENCY_A) {
                    onFieldAInput(formatInput);
                } else {
                    onFieldBInput(formatInput);
                }
            }
        }
    }, [
        maxAmounts,
        maxZappableAmount,
        onFieldAInput,
        onFieldBInput,
        swapTokenField
    ]);
    var totalSupply = (0,hooks_useTotalSupply__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z)(pair === null || pair === void 0 ? void 0 : pair.liquidityToken);
    // liquidity minted
    var liquidityMinted = (0,react__WEBPACK_IMPORTED_MODULE_12__.useMemo)(function() {
        if (!pair || !swapTokens[swapTokenField] || !swapTokens[swapOutTokenField] || !(zapInEstimated === null || zapInEstimated === void 0 ? void 0 : zapInEstimated.swapAmountIn) || !(zapInEstimated === null || zapInEstimated === void 0 ? void 0 : zapInEstimated.swapAmountOut) || !wrappedParsedAmounts[swapTokenField]) {
            return undefined;
        }
        if (pair && totalSupply) {
            try {
                // calc the tokenA amount after swap
                var zappedTokenAmountA = wrappedParsedAmounts[swapTokenField].greaterThan(zapInEstimated.swapAmountIn.toString()) ? wrappedParsedAmounts[swapTokenField].subtract(_pancakeswap_sdk__WEBPACK_IMPORTED_MODULE_1__/* .CurrencyAmount.fromRawAmount */ .ih.fromRawAmount(swapTokens[swapTokenField], zapInEstimated.swapAmountIn.toString())) : wrappedParsedAmounts[swapTokenField];
                var zappedTokenAmountB = _pancakeswap_sdk__WEBPACK_IMPORTED_MODULE_1__/* .CurrencyAmount.fromRawAmount */ .ih.fromRawAmount(swapTokens[swapOutTokenField], zapInEstimated.swapAmountOut.toString());
                if (wrappedParsedAmounts[swapOutTokenField]) {
                    zappedTokenAmountB = zappedTokenAmountB.add(wrappedParsedAmounts[swapOutTokenField]);
                }
                var lpMinted = pair.getLiquidityMinted(totalSupply, zappedTokenAmountA, zappedTokenAmountB);
                return lpMinted;
            } catch (error) {
                console.error(error);
                return undefined;
            }
        }
        return undefined;
    }, [
        pair,
        swapTokens,
        swapTokenField,
        swapOutTokenField,
        zapInEstimated === null || zapInEstimated === void 0 ? void 0 : zapInEstimated.swapAmountIn,
        zapInEstimated === null || zapInEstimated === void 0 ? void 0 : zapInEstimated.swapAmountOut,
        wrappedParsedAmounts,
        totalSupply, 
    ]);
    var swapTokenAmountTooLow = (0,react__WEBPACK_IMPORTED_MODULE_12__.useMemo)(function() {
        return wrappedParsedAmounts[swapTokenField] && _pancakeswap_sdk__WEBPACK_IMPORTED_MODULE_1__/* .JSBI.lessThan */ .QA.lessThan(wrappedParsedAmounts[swapTokenField].quotient, _pancakeswap_sdk__WEBPACK_IMPORTED_MODULE_1__/* .MINIMUM_LIQUIDITY */ .Xh);
    }, [
        swapTokenField,
        wrappedParsedAmounts
    ]);
    var swapOutAmountTooLow = (0,react__WEBPACK_IMPORTED_MODULE_12__.useMemo)(function() {
        return wrappedParsedAmounts[swapOutTokenField] && _pancakeswap_sdk__WEBPACK_IMPORTED_MODULE_1__/* .JSBI.lessThan */ .QA.lessThan(wrappedParsedAmounts[swapOutTokenField].quotient, _pancakeswap_sdk__WEBPACK_IMPORTED_MODULE_1__/* .MINIMUM_LIQUIDITY */ .Xh);
    }, [
        swapOutTokenField,
        wrappedParsedAmounts
    ]);
    var poolTokenPercentage = (0,react__WEBPACK_IMPORTED_MODULE_12__.useMemo)(function() {
        if (liquidityMinted && totalSupply) {
            return new _pancakeswap_sdk__WEBPACK_IMPORTED_MODULE_1__/* .Percent */ .gG(liquidityMinted.quotient, totalSupply.add(liquidityMinted).quotient);
        }
        return undefined;
    }, [
        liquidityMinted,
        totalSupply
    ]);
    var gasOverhead = useZapInGasOverhead((0,react__WEBPACK_IMPORTED_MODULE_12__.useMemo)(function() {
        return zapInEstimated ? _pancakeswap_sdk__WEBPACK_IMPORTED_MODULE_1__/* .CurrencyAmount.fromRawAmount */ .ih.fromRawAmount(swapTokens[swapTokenField], zapInEstimated.swapAmountIn.toString()) : null;
    }, [
        swapTokenField,
        swapTokens,
        zapInEstimated
    ]));
    (0,react__WEBPACK_IMPORTED_MODULE_12__.useEffect)(function() {
        if (!triedAutoReduce && parsedAmounts[swapTokenField] && maxZappableAmount && !previousBlur && inputBlurOnce && !rebalancing) {
            if (_pancakeswap_sdk__WEBPACK_IMPORTED_MODULE_1__/* .JSBI.greaterThan */ .QA.greaterThan(parsedAmounts[swapTokenField].quotient, maxZappableAmount)) {
                convertToMaxZappable();
                setTriedAutoReduce(true);
            }
        }
    }, [
        convertToMaxZappable,
        inputBlurOnce,
        maxZappableAmount,
        parsedAmounts,
        previousBlur,
        rebalancing,
        singleTokenToZapAmount,
        swapTokenField,
        triedAutoReduce, 
    ]);
    var onInputBlurOnce = (0,react__WEBPACK_IMPORTED_MODULE_12__.useCallback)(function() {
        setInputBlurOnce(true);
    }, []);
    var error;
    if (zapInEstimatedError) {
        error = t("Cannot estimate zap amount");
    }
    if (swapTokenAmountTooLow || rebalancing && swapOutAmountTooLow) {
        error = t("Zap in amount too low");
    }
    if (wrappedParsedAmounts[swapTokenField] && ((ref2 = currencyBalances[swapTokenField]) === null || ref2 === void 0 ? void 0 : ref2.lessThan(wrappedParsedAmounts[swapTokenField]))) {
        var ref8;
        var _symbol;
        error = t("Insufficient %token% balance", {
            token: (_symbol = (ref8 = wrappedParsedAmounts[swapTokenField]) === null || ref8 === void 0 ? void 0 : ref8.currency.symbol) !== null && _symbol !== void 0 ? _symbol : ""
        });
    }
    if (wrappedParsedAmounts[swapOutTokenField] && rebalancing && ((ref3 = currencyBalances[swapOutTokenField]) === null || ref3 === void 0 ? void 0 : ref3.lessThan(wrappedParsedAmounts[swapOutTokenField]))) {
        var ref9;
        var _symbol1;
        error = t("Insufficient %token% balance", {
            token: (_symbol1 = (ref9 = wrappedParsedAmounts[swapOutTokenField]) === null || ref9 === void 0 ? void 0 : ref9.currency.symbol) !== null && _symbol1 !== void 0 ? _symbol1 : ""
        });
    }
    return {
        zapInEstimating: zapInEstimatedStatus !== config_constants_types__WEBPACK_IMPORTED_MODULE_3__/* .FetchStatus.Fetched */ .iF.Fetched,
        zapInEstimatedError: zapInEstimatedError,
        zapInEstimated: zapInEstimated,
        error: error,
        liquidityMinted: liquidityMinted,
        poolTokenPercentage: poolTokenPercentage,
        parsedAmounts: parsedAmounts,
        swapTokenField: swapTokenField,
        swapOutTokenField: swapOutTokenField,
        priceSeverity: priceSeverity,
        convertToMaxZappable: convertToMaxZappable,
        rebalancing: rebalancing,
        noNeedZap: noNeedZap,
        gasOverhead: gasOverhead,
        isDependentAmountGreaterThanMaxAmount: isDependentAmountGreaterThanMaxAmount,
        onInputBlurOnce: onInputBlurOnce
    };
}


/***/ }),

/***/ 24651:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "L": function() { return /* binding */ useStableLPDerivedMintInfo; },
/* harmony export */   "o": function() { return /* binding */ useStablePair; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(47568);
/* harmony import */ var _swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_16__ = __webpack_require__(14924);
/* harmony import */ var _swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(97582);
/* harmony import */ var _pancakeswap_localization__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(52775);
/* harmony import */ var _pancakeswap_sdk__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(82125);
/* harmony import */ var config_constants_exchange__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(56974);
/* harmony import */ var hooks_useActiveWeb3React__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(97477);
/* harmony import */ var hooks_usePairs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(71633);
/* harmony import */ var hooks_useTotalSupply__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(19639);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(67294);
/* harmony import */ var _pancakeswap_utils_tryParseAmount__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(68492);
/* harmony import */ var state_mint_actions__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(21568);
/* harmony import */ var state_wallet_hooks__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(5460);
/* harmony import */ var views_Swap_StableSwap_hooks_useStableConfig__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(12353);
/* harmony import */ var views_Swap_StableSwap_hooks_useStableTradeExactIn__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(14103);
/* harmony import */ var swr__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(8100);
/* harmony import */ var state_mint_hooks__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(50192);

















function useStablePair(currencyA, currencyB) {
    var ref;
    var ref1 = (0,react__WEBPACK_IMPORTED_MODULE_6__.useContext)(views_Swap_StableSwap_hooks_useStableConfig__WEBPACK_IMPORTED_MODULE_10__/* .StableConfigContext */ .UA), stableSwapConfig = ref1.stableSwapConfig, stableSwapContract = ref1.stableSwapContract;
    var currencyAAmountQuotient = (ref = (0,_pancakeswap_utils_tryParseAmount__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)("1", currencyA)) === null || ref === void 0 ? void 0 : ref.quotient;
    var ref2 = (0,views_Swap_StableSwap_hooks_useStableTradeExactIn__WEBPACK_IMPORTED_MODULE_11__/* .useEstimatedAmount */ .GS)({
        estimatedCurrency: currencyB,
        quotient: currencyAAmountQuotient === null || currencyAAmountQuotient === void 0 ? void 0 : currencyAAmountQuotient.toString(),
        stableSwapContract: stableSwapContract,
        stableSwapConfig: stableSwapConfig
    }), estimatedToken1Amount = ref2.data;
    var pair = (0,react__WEBPACK_IMPORTED_MODULE_6__.useMemo)(function() {
        var isPriceValid = currencyAAmountQuotient && estimatedToken1Amount;
        var ZERO_AMOUNT = _pancakeswap_sdk__WEBPACK_IMPORTED_MODULE_1__/* .CurrencyAmount.fromRawAmount */ .ih.fromRawAmount(currencyB, "0");
        var token0Price = isPriceValid ? new _pancakeswap_sdk__WEBPACK_IMPORTED_MODULE_1__/* .Price */ .tA(currencyA, currencyB, currencyAAmountQuotient, estimatedToken1Amount.quotient) : ZERO_AMOUNT;
        return {
            liquidityToken: (stableSwapConfig === null || stableSwapConfig === void 0 ? void 0 : stableSwapConfig.liquidityToken) || null,
            tokenAmounts: [],
            token0: currencyA,
            token1: currencyB,
            priceOf: function(token) {
                return isPriceValid ? (token === null || token === void 0 ? void 0 : token.address) === (currencyA === null || currencyA === void 0 ? void 0 : currencyA.address) ? token0Price : token0Price.invert() : ZERO_AMOUNT;
            },
            token0Price: function() {
                return token0Price;
            },
            token1Price: function() {
                return token0Price.invert();
            },
            // NOTE: Stable Tokens don't need this
            reserve1: ZERO_AMOUNT,
            reserve0: ZERO_AMOUNT,
            getLiquidityValue: function() {
                return ZERO_AMOUNT;
            }
        };
    }, [
        stableSwapConfig === null || stableSwapConfig === void 0 ? void 0 : stableSwapConfig.liquidityToken,
        currencyA,
        currencyB,
        currencyAAmountQuotient,
        estimatedToken1Amount
    ]);
    if (!stableSwapConfig) {
        return {
            pairState: hooks_usePairs__WEBPACK_IMPORTED_MODULE_4__/* .PairState.NOT_EXISTS */ ._G.NOT_EXISTS,
            pair: undefined
        };
    }
    return {
        pairState: hooks_usePairs__WEBPACK_IMPORTED_MODULE_4__/* .PairState.EXISTS */ ._G.EXISTS,
        pair: pair
    };
}
function useMintedStabelLP(param) {
    var stableSwapInfoContract = param.stableSwapInfoContract, stableSwapConfig = param.stableSwapConfig, stableSwapAddress = param.stableSwapAddress, currencyInput = param.currencyInput, currencyInputAmount = param.currencyInputAmount, currencyOutputAmount = param.currencyOutputAmount;
    var quotient0Str = currencyInputAmount === null || currencyInputAmount === void 0 ? void 0 : currencyInputAmount.toString();
    var quotient1Str = currencyOutputAmount === null || currencyOutputAmount === void 0 ? void 0 : currencyOutputAmount.toString();
    var isValid = !!stableSwapAddress && !!quotient0Str && !!quotient1Str;
    return (0,swr__WEBPACK_IMPORTED_MODULE_12__/* ["default"] */ .ZP)(isValid ? [
        "get_add_liquidity_mint_amount",
        stableSwapAddress,
        quotient0Str,
        quotient1Str
    ] : null, /*#__PURE__*/ (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_14__/* ["default"] */ .Z)(function() {
        var ref, isToken0, amounts;
        return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_15__.__generator)(this, function(_state) {
            isToken0 = (stableSwapConfig === null || stableSwapConfig === void 0 ? void 0 : (ref = stableSwapConfig.token0) === null || ref === void 0 ? void 0 : ref.address) === (currencyInput === null || currencyInput === void 0 ? void 0 : currencyInput.address);
            amounts = isToken0 ? [
                quotient0Str,
                quotient1Str
            ] : [
                quotient1Str,
                quotient0Str
            ];
            return [
                2,
                stableSwapInfoContract.get_add_liquidity_mint_amount(stableSwapAddress, amounts)
            ];
        });
    }));
}
function useStableLPDerivedMintInfo(currencyA, currencyB) {
    var ref, ref1, ref2, ref3;
    var account = (0,hooks_useActiveWeb3React__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)().account;
    var t = (0,_pancakeswap_localization__WEBPACK_IMPORTED_MODULE_0__/* .useTranslation */ .$G)().t;
    var ref4 = (0,state_mint_hooks__WEBPACK_IMPORTED_MODULE_13__/* .useMintState */ .OY)(), independentField = ref4.independentField, typedValue = ref4.typedValue, otherTypedValue = ref4.otherTypedValue;
    var dependentField = independentField === state_mint_actions__WEBPACK_IMPORTED_MODULE_8__/* .Field.CURRENCY_A */ .gN.CURRENCY_A ? state_mint_actions__WEBPACK_IMPORTED_MODULE_8__/* .Field.CURRENCY_B */ .gN.CURRENCY_B : state_mint_actions__WEBPACK_IMPORTED_MODULE_8__/* .Field.CURRENCY_A */ .gN.CURRENCY_A;
    // tokens
    var currencies = (0,react__WEBPACK_IMPORTED_MODULE_6__.useMemo)(function() {
        var _obj;
        return _obj = {}, (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_16__/* ["default"] */ .Z)(_obj, state_mint_actions__WEBPACK_IMPORTED_MODULE_8__/* .Field.CURRENCY_A */ .gN.CURRENCY_A, currencyA !== null && currencyA !== void 0 ? currencyA : undefined), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_16__/* ["default"] */ .Z)(_obj, state_mint_actions__WEBPACK_IMPORTED_MODULE_8__/* .Field.CURRENCY_B */ .gN.CURRENCY_B, currencyB !== null && currencyB !== void 0 ? currencyB : undefined), _obj;
    }, [
        currencyA,
        currencyB
    ]);
    // pair
    var ref5 = useStablePair(currencyA === null || currencyA === void 0 ? void 0 : currencyA.wrapped, currencyB === null || currencyB === void 0 ? void 0 : currencyB.wrapped), pairState = ref5.pairState, pair = ref5.pair;
    var totalSupply = (0,hooks_useTotalSupply__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(pair === null || pair === void 0 ? void 0 : pair.liquidityToken);
    var noLiquidity = pairState === hooks_usePairs__WEBPACK_IMPORTED_MODULE_4__/* .PairState.NOT_EXISTS */ ._G.NOT_EXISTS || Boolean(totalSupply && _pancakeswap_sdk__WEBPACK_IMPORTED_MODULE_1__/* .JSBI.equal */ .QA.equal(totalSupply.quotient, config_constants_exchange__WEBPACK_IMPORTED_MODULE_2__/* .BIG_INT_ZERO */ .iV));
    // balances
    var balances = (0,state_wallet_hooks__WEBPACK_IMPORTED_MODULE_9__/* .useCurrencyBalances */ .K5)(account !== null && account !== void 0 ? account : undefined, [
        currencyA,
        currencyB
    ]);
    var _obj;
    var currencyBalances = (_obj = {}, (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_16__/* ["default"] */ .Z)(_obj, state_mint_actions__WEBPACK_IMPORTED_MODULE_8__/* .Field.CURRENCY_A */ .gN.CURRENCY_A, balances[0]), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_16__/* ["default"] */ .Z)(_obj, state_mint_actions__WEBPACK_IMPORTED_MODULE_8__/* .Field.CURRENCY_B */ .gN.CURRENCY_B, balances[1]), _obj);
    // amounts
    var independentAmount = (0,_pancakeswap_utils_tryParseAmount__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)(typedValue, currencies[independentField]);
    var dependentAmount = (0,_pancakeswap_utils_tryParseAmount__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)(otherTypedValue, currencies[dependentField]);
    var parsedAmounts = (0,react__WEBPACK_IMPORTED_MODULE_6__.useMemo)(function() {
        var _obj;
        return _obj = {}, (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_16__/* ["default"] */ .Z)(_obj, state_mint_actions__WEBPACK_IMPORTED_MODULE_8__/* .Field.CURRENCY_A */ .gN.CURRENCY_A, independentField === state_mint_actions__WEBPACK_IMPORTED_MODULE_8__/* .Field.CURRENCY_A */ .gN.CURRENCY_A ? independentAmount : dependentAmount), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_16__/* ["default"] */ .Z)(_obj, state_mint_actions__WEBPACK_IMPORTED_MODULE_8__/* .Field.CURRENCY_B */ .gN.CURRENCY_B, independentField === state_mint_actions__WEBPACK_IMPORTED_MODULE_8__/* .Field.CURRENCY_A */ .gN.CURRENCY_A ? dependentAmount : independentAmount), _obj;
    }, [
        dependentAmount,
        independentAmount,
        independentField
    ]);
    var ref6 = (0,react__WEBPACK_IMPORTED_MODULE_6__.useContext)(views_Swap_StableSwap_hooks_useStableConfig__WEBPACK_IMPORTED_MODULE_10__/* .StableConfigContext */ .UA), stableSwapConfig = ref6.stableSwapConfig, stableSwapContract = ref6.stableSwapContract, stableSwapInfoContract = ref6.stableSwapInfoContract;
    var currencyAAmount = parsedAmounts[state_mint_actions__WEBPACK_IMPORTED_MODULE_8__/* .Field.CURRENCY_A */ .gN.CURRENCY_A], currencyBAmount = parsedAmounts[state_mint_actions__WEBPACK_IMPORTED_MODULE_8__/* .Field.CURRENCY_B */ .gN.CURRENCY_B];
    var currencyAAmountQuotient = currencyAAmount === null || currencyAAmount === void 0 ? void 0 : currencyAAmount.quotient;
    var currencyBAmountQuotient = currencyBAmount === null || currencyBAmount === void 0 ? void 0 : currencyBAmount.quotient;
    var ref7 = (0,views_Swap_StableSwap_hooks_useStableTradeExactIn__WEBPACK_IMPORTED_MODULE_11__/* .useEstimatedAmount */ .GS)({
        estimatedCurrency: currencyAAmountQuotient ? currencyB : currencyA,
        quotient: currencyAAmountQuotient ? currencyAAmountQuotient === null || currencyAAmountQuotient === void 0 ? void 0 : currencyAAmountQuotient.toString() : currencyBAmountQuotient === null || currencyBAmountQuotient === void 0 ? void 0 : currencyBAmountQuotient.toString(),
        stableSwapConfig: stableSwapConfig,
        stableSwapContract: stableSwapContract
    }), estimatedOutputAmount = ref7.data;
    var price = (0,react__WEBPACK_IMPORTED_MODULE_6__.useMemo)(function() {
        var isEstimatedOutputAmountZero = estimatedOutputAmount === null || estimatedOutputAmount === void 0 ? void 0 : estimatedOutputAmount.equalTo(0);
        if ((currencyAAmountQuotient || currencyBAmountQuotient) && estimatedOutputAmount && !isEstimatedOutputAmountZero) {
            return currencyAAmountQuotient ? new _pancakeswap_sdk__WEBPACK_IMPORTED_MODULE_1__/* .Price */ .tA(currencyA, currencyB, currencyAAmountQuotient, estimatedOutputAmount.quotient) : new _pancakeswap_sdk__WEBPACK_IMPORTED_MODULE_1__/* .Price */ .tA(currencyA, currencyB, estimatedOutputAmount.quotient, currencyBAmountQuotient);
        }
        return undefined;
    }, [
        estimatedOutputAmount,
        currencyA,
        currencyB,
        currencyBAmountQuotient,
        currencyAAmountQuotient
    ]);
    var ref8 = useMintedStabelLP({
        stableSwapAddress: stableSwapConfig === null || stableSwapConfig === void 0 ? void 0 : stableSwapConfig.stableSwapAddress,
        stableSwapInfoContract: stableSwapInfoContract,
        stableSwapConfig: stableSwapConfig,
        currencyInput: currencyAAmountQuotient ? currencyA : currencyB,
        currencyInputAmount: currencyAAmountQuotient || currencyBAmountQuotient,
        currencyOutputAmount: currencyAAmountQuotient ? currencyBAmountQuotient : currencyAAmountQuotient
    }), lpMinted = ref8.data;
    // liquidity minted
    var liquidityMinted = (0,react__WEBPACK_IMPORTED_MODULE_6__.useMemo)(function() {
        if ((pair === null || pair === void 0 ? void 0 : pair.liquidityToken) && totalSupply && lpMinted) {
            try {
                return _pancakeswap_sdk__WEBPACK_IMPORTED_MODULE_1__/* .CurrencyAmount.fromRawAmount */ .ih.fromRawAmount(pair === null || pair === void 0 ? void 0 : pair.liquidityToken, lpMinted === null || lpMinted === void 0 ? void 0 : lpMinted.toString());
            } catch (error) {
                console.error(error);
                return undefined;
            }
        }
        return undefined;
    }, [
        pair === null || pair === void 0 ? void 0 : pair.liquidityToken,
        totalSupply,
        lpMinted
    ]);
    var poolTokenPercentage = (0,react__WEBPACK_IMPORTED_MODULE_6__.useMemo)(function() {
        if (liquidityMinted && totalSupply) {
            return new _pancakeswap_sdk__WEBPACK_IMPORTED_MODULE_1__/* .Percent */ .gG(liquidityMinted.quotient, totalSupply.add(liquidityMinted).quotient);
        }
        return undefined;
    }, [
        liquidityMinted,
        totalSupply
    ]);
    var error;
    var addError;
    if (!account) {
        error = t("Connect Wallet");
    }
    if (pairState === hooks_usePairs__WEBPACK_IMPORTED_MODULE_4__/* .PairState.INVALID */ ._G.INVALID) {
        error = error !== null && error !== void 0 ? error : t("Choose a valid pair");
    }
    if (currencyAAmount && currencyBAmount && (currencyBalances === null || currencyBalances === void 0 ? void 0 : (ref = currencyBalances[state_mint_actions__WEBPACK_IMPORTED_MODULE_8__/* .Field.CURRENCY_A */ .gN.CURRENCY_A]) === null || ref === void 0 ? void 0 : ref.equalTo(0)) && (currencyBalances === null || currencyBalances === void 0 ? void 0 : (ref1 = currencyBalances[state_mint_actions__WEBPACK_IMPORTED_MODULE_8__/* .Field.CURRENCY_B */ .gN.CURRENCY_B]) === null || ref1 === void 0 ? void 0 : ref1.equalTo(0))) {
        error = error !== null && error !== void 0 ? error : t("No token balance");
    }
    if (!parsedAmounts[state_mint_actions__WEBPACK_IMPORTED_MODULE_8__/* .Field.CURRENCY_A */ .gN.CURRENCY_A] || !parsedAmounts[state_mint_actions__WEBPACK_IMPORTED_MODULE_8__/* .Field.CURRENCY_B */ .gN.CURRENCY_B]) {
        addError = t("Enter an amount");
    }
    if (currencyAAmount && (currencyBalances === null || currencyBalances === void 0 ? void 0 : (ref2 = currencyBalances[state_mint_actions__WEBPACK_IMPORTED_MODULE_8__/* .Field.CURRENCY_A */ .gN.CURRENCY_A]) === null || ref2 === void 0 ? void 0 : ref2.lessThan(currencyAAmount))) {
        var ref9;
        addError = t("Insufficient %symbol% balance", {
            symbol: (ref9 = currencies[state_mint_actions__WEBPACK_IMPORTED_MODULE_8__/* .Field.CURRENCY_A */ .gN.CURRENCY_A]) === null || ref9 === void 0 ? void 0 : ref9.symbol
        });
    }
    if (currencyBAmount && (currencyBalances === null || currencyBalances === void 0 ? void 0 : (ref3 = currencyBalances[state_mint_actions__WEBPACK_IMPORTED_MODULE_8__/* .Field.CURRENCY_B */ .gN.CURRENCY_B]) === null || ref3 === void 0 ? void 0 : ref3.lessThan(currencyBAmount))) {
        var ref10;
        addError = t("Insufficient %symbol% balance", {
            symbol: (ref10 = currencies[state_mint_actions__WEBPACK_IMPORTED_MODULE_8__/* .Field.CURRENCY_B */ .gN.CURRENCY_B]) === null || ref10 === void 0 ? void 0 : ref10.symbol
        });
    }
    return {
        dependentField: dependentField,
        currencies: currencies,
        pair: pair,
        pairState: pairState,
        currencyBalances: currencyBalances,
        parsedAmounts: parsedAmounts,
        price: price,
        noLiquidity: noLiquidity,
        liquidityMinted: liquidityMinted,
        poolTokenPercentage: poolTokenPercentage,
        error: error,
        addError: addError
    };
}


/***/ })

}]);